import React, { Fragment, useState } from "react";
import { useIntl } from "react-intl";
import NavHistoryTab from "./NavHistoryTab";
import TopHoldingTab from "./TopHoldingTab";
import SyncStatusTab from "./SyncStatusTab";
import LatestByFundTab from "./LatestByFundTab";
import messages from "./messages";
import "react-datepicker/dist/react-datepicker.css";
import "./style.scss";

/**
 * Operator view over everything the NAV sync writes: funds_nav_history, funds_top_holding and
 * funds_sync_state.
 *
 * One left-menu entry with three tabs rather than a parent menu with three children. The sidebar's
 * sub-menu behaviour is not derived from `children`: it is hand-maintained in three places
 * (LeftMenu's nestedMappings and idMappings, and SideBar's indexMap), and one of them lives in a
 * file this change does not own - a parent entry whose children never expand would be worse than
 * no parent at all. Every flat entry in the menu behaves exactly like this one.
 */
const TAB_NAV_HISTORY = "nav_history";
const TAB_TOP_HOLDING = "top_holding";
const TAB_SYNC_STATUS = "sync_status";
const TAB_LATEST_BY_FUND = "latest_by_fund";

function NavList() {
  const intl = useIntl();
  const [tab, setTab] = useState(TAB_NAV_HISTORY);

  const renderTab = () => {
    if (tab === TAB_TOP_HOLDING) {
      return <TopHoldingTab />;
    }
    if (tab === TAB_SYNC_STATUS) {
      return <SyncStatusTab />;
    }
    if (tab === TAB_LATEST_BY_FUND) {
      return <LatestByFundTab />;
    }
    return <NavHistoryTab />;
  };

  return (
    <Fragment>
      <div className="nav-tabs-container">
        <div className="nav-tabs-bar">
          <button
            className={tab === TAB_NAV_HISTORY ? "nav-tabs nav-active-tabs" : "nav-tabs"}
            onClick={() => setTab(TAB_NAV_HISTORY)}
          >
            {intl.formatMessage(messages.tabNavHistory)}
          </button>
          <button
            className={tab === TAB_LATEST_BY_FUND ? "nav-tabs nav-active-tabs" : "nav-tabs"}
            onClick={() => setTab(TAB_LATEST_BY_FUND)}
          >
            {intl.formatMessage(messages.tabLatestByFund)}
          </button>
          <button
            className={tab === TAB_TOP_HOLDING ? "nav-tabs nav-active-tabs" : "nav-tabs"}
            onClick={() => setTab(TAB_TOP_HOLDING)}
          >
            {intl.formatMessage(messages.tabTopHolding)}
          </button>
          <button
            className={tab === TAB_SYNC_STATUS ? "nav-tabs nav-active-tabs" : "nav-tabs"}
            onClick={() => setTab(TAB_SYNC_STATUS)}
          >
            {intl.formatMessage(messages.tabSyncStatus)}
          </button>
        </div>
      </div>

      {renderTab()}
    </Fragment>
  );
}

export default NavList;
